import { render, staticRenderFns } from "./ProductHighlight.vue?vue&type=template&id=e19bfab6&scoped=true"
import script from "./ProductHighlight.vue?vue&type=script&lang=js"
export * from "./ProductHighlight.vue?vue&type=script&lang=js"
import style0 from "./ProductHighlight.vue?vue&type=style&index=0&id=e19bfab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19bfab6",
  null
  
)

export default component.exports